export const ADS_LOADING = 'ADS_LOADING';
export const INIT_BLOCK = 'INIT_BLOCK';
export const BLOCK_COMPLETED = 'BLOCK_COMPLETED';
export const STATUS_CHANGED = 'STATUS_CHANGED';
